import common from './common';
import mobile_app from './common';
import backend from './common';
import flow from './flow';
import web from './web';

export { common, backend, flow, mobile_app, web };
const defs = { common, backend, flow, mobile_app, web };
export default defs;
